// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2L7ch","title":"Images45_title__1nrTL","images":"Images45_images__3b1Qc"};